import { Tag } from 'antd'

const COLORS: Record<string, string> = {
  ACTIVE: 'green',
  INACTIVE: 'default',
  SUSPENDED: 'orange',
  DRAFT: 'blue',
  EXPIRED: 'red',
  CANCELLED: 'red',
  REVOKED: 'red',
  BLOCKED: 'red',
}

export function StatusBadge({ status }: { status: string }) {
  const color = COLORS[status] ?? 'default'
  return <Tag color={color}>{status}</Tag>
}
